/*
 * Copyright (c) 2019 - Convergence Labs, Inc.
 *
 * This file is part of the Convergence Server, which is released under
 * the terms of the GNU General Public License version 3 (GPLv3). A copy
 * of the GPLv3 should have been provided along with this file, typically
 * located in the "LICENSE" file, which is part of this source code package.
 * Alternatively, see <https://www.gnu.org/licenses/gpl-3.0.html> for the
 * full text of the GPLv3 license, if it was not provided.
 */

import {StringElement, StringInsertEvent, StringRemoveEvent, StringValueEvent} from "../../../model/StringElement";
import {TreeNode} from "./TreeNode";
import {ModelElementEvent} from "../../../model/ModelElement";

export class StringNode extends TreeNode<StringElement> {
  protected _handleElementEvent(e: ModelElementEvent): void {
    // FIXME need to emit granular events
    if (e instanceof StringValueEvent) {
      this._emitChanged(e.remote);
    } else if (e instanceof StringInsertEvent) {
      this._emitChanged(e.remote);
    } else if (e instanceof StringRemoveEvent) {
      this._emitChanged(e.remote);
    }
  }
}
